import React from 'react';

const SearchIcon: React.FC = () => (
  <svg width="29" height="35" viewBox="0 0 29 35" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <style>
        {`.important-fill { fill: #6769B0 !important; }`}
      </style>
    </defs>
    <circle cx="11.3137" cy="19.3108" r="7" transform="rotate(-45 11.3137 19.3108)" stroke="#6769B0" strokeWidth="2"/>
    <path d="M16.2637 24.2605L21.2134 29.2102" stroke="#6769B0" strokeWidth="2" strokeLinecap="round"/>
    <path d="M15 10.1331C19.875 10.1331 22 8.08206 22 3.13306C22 8.08206 24.11 10.1331 29 10.1331C24.11 10.1331 22 12.2431 22 17.1331C22 12.2431 19.875 10.1331 15 10.1331ZM11 4.63306C14.134 4.63306 15.5 3.31506 15.5 0.133057C15.5 3.31506 16.857 4.63306 20 4.63306C16.857 4.63306 15.5 5.99006 15.5 9.13306C15.5 5.99006 14.134 4.63306 11 4.63306Z" className="important-fill"/>
  </svg>
);

export default SearchIcon;
